// What actually went wrong, in words the agent can act on. The server now names
// the offending column on a failed commit; the cases with NO response are the
// ones worth naming separately, because "Import failed" on its own sent Simon
// Abbott looking for a problem in his spreadsheet that wasn't there (26 Aug 2026).
export const importError = (e) => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (e?.response?.status >= 500) {
    return "The server hit an error part-way through and nothing was saved. Try again, and tell us if it keeps happening.";
  }
  if (!e?.response) {
    // No response at all: the upload timed out (a big sheet can outrun the
    // 30-second limit), or the connection dropped.
    return "The upload didn't get a reply - it may have taken too long. Nothing was saved; try importing one tab at a time.";
  }
  return "Import failed";
};
